import styled from 'styled-components/native';
import { Feather as IconsFE, FontAwesome5 as IconsFA5 } from '@expo/vector-icons';
import { themes } from '../../../design/colors';
import { Camera as ExpoCamera } from 'expo-camera';
import Constants from 'expo-constants';

export const Container = styled.View`
    flex: 1;
`;

export const Content = styled.View`
    padding: 20px;
`;

export const Header = styled.View`
    background-color: ${themes.colors.primary};
    padding: ${Constants.statusBarHeight + 12}px 16px 15px 16px;
    flex-direction: row;
    justify-content: space-between;
`;

export const Title = styled.Text`
    color: ${themes.colors.white};
    font-size: 16px;
    font-weight: bold;
`;

export const IconFE = styled(IconsFE)``;

export const IconFA5 = styled(IconsFA5)``;

export const TextButtonSend = styled.Text`
  color: ${themes.colors.white};
  font-weight: bold;
  font-size: 16px;
`;


export const ButtonSend = styled.TouchableOpacity`
  background-color: ${themes.colors.primary};
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  height: 50px;
  border-radius: 5px;
`;


export const Photo = styled.Image`
  shadow-color: ${themes.colors.black};
  shadow-opacity: 0.23px;
  shadow-radius: 2.62px;
  elevation: 1px;
  border-radius: 5px;
  height: 81.5%;
`;


export const TextButtonNewPhoto = styled.Text`
  color: ${themes.colors.white};
  font-weight: bold;
  font-size: 16px;
`;


export const ButtonNewPhoto = styled.TouchableOpacity`
  background-color: #E74040;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  height: 50px;
  border-radius: 5px;
  width: 100%;
  margin-bottom: 10px;
`;


export const ButtonTakePhoto = styled.TouchableOpacity`
  justify-content: center;
  align-items: center;
  background-color: #9e9e9e6e;
  margin: 20px;
  border-radius: 10px;
  padding: 10px;
  height: 60px;
  border-radius: 100px;
  width: 60px;
`;


export const ContentButtonCamera = styled.View`
  flex: 1;
  justify-content: center;
  bottom: 0px;
  position: absolute;
  margin-left: 36%;
`;


export const Camera = styled(ExpoCamera)`
  shadow-color: #000;
  shadow-opacity: 0.23px;
  shadow-radius: 2.62px;
  margin-top: 5px;
  elevation: 1px;
  height: 98.5%;
  border-radius: 5px;
`;